/* eslint-disable react/jsx-key */
import React, { Component } from 'react';
import FormGroup from '@mui/material/FormGroup';
import Text from '../Text.js';
import Modal from './Modal.js';
import * as Theme from '../../theme/index.js';
import { lsaOptions } from '../../services/constants.js';
import Icon from "@mui/material/Icon";
import { styled } from '@mui/system';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const FullScreenBlock = styled("div")(({
  theme
}) => ({
  display: 'block',
  [theme.breakpoints.down(750)]: {
    display: 'none'
  }
}));
const MobileColumn = styled("div")(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.down(750)]: {
    display: 'block',
    width: '100%'
  }
}));
const labelsMap = {
  Health: i18n.t(tokens.labels.health),
  Alternative: i18n.t(tokens.labels.lsaModal.alternativePractitioner),
  Cosmetic: i18n.t(tokens.labels.lsaModal.cosmetic),
  Personal: i18n.t(tokens.labels.lsaModal.personal),
  FitnessAndSports: i18n.t(tokens.labels.lsaModal.fitnessAndSports),
  Other: i18n.t(tokens.labels.account.other)
};

/**
 * 
 * @param {*} item 
 * @param {*} hideDisabledLsaItems 
 * @returns 
 */
const DisabledLsaItem = ({
  item,
  hideDisabledLsaItems = false
}) => /*#__PURE__*/React.createElement(React.Fragment, null, !hideDisabledLsaItems ? /*#__PURE__*/React.createElement("div", {
  style: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15
  }
}, /*#__PURE__*/React.createElement(Text, {
  mediumBold: true,
  medium: true,
  margin: "0 0 0 5px",
  color: Theme.colors.mediumLightGrey
}, localizationMaps.fromEnglish('benefits', item))) : null);

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const LsaColumn = ({
  whitelabel,
  hideDisabledLsaItems = false,
  selectedItems,
  options,
  width = '30%'
}) => {
  const showItem = hideDisabledLsaItems ? selectedItems.some(e => e) : true;
  const styles = {
    itemBlock: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 15
    },
    lsaColumn: {
      width
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showItem ? /*#__PURE__*/React.createElement(FormGroup, {
    sx: styles.lsaColumn
  }, options?.map(item => {
    if (selectedItems?.includes(item)) {
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Icon, {
        style: {
          color: whitelabel.primaryColor || Theme.colors.skyBlue
        }
      }, "check_box"), /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px"
      }, localizationMaps.fromEnglish('benefits', item)));
    }
    return /*#__PURE__*/React.createElement(DisabledLsaItem, {
      item: item,
      hideDisabledLsaItems: hideDisabledLsaItems
    });
  })) : null);
};

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const LsaTitle = ({
  title,
  hideDisabledLsaItems = false,
  selectedItems,
  width = '30%'
}) => {
  const showTitle = hideDisabledLsaItems ? selectedItems.some(e => e) : true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTitle ? /*#__PURE__*/React.createElement("div", {
    style: {
      width
    }
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true
  }, title)) : null);
};

/**
 * @param classes
 * @returns {*}
 * @constructor
 */
class LsaCategoriesModal extends Component {
  state = {
    selectedItems: null,
    rowOne: [],
    rowTwo: []
  };
  async componentDidMount() {
    let selectedItems = this.props.items || (await this.props.getItems());

    // if the items are not already categorized then categorize them
    if (!selectedItems || !selectedItems.Health) {
      selectedItems = await this._categorizeItems(selectedItems);
    }
    const {
      rowOne,
      rowTwo
    } = this._getRows(selectedItems);
    this.setState({
      selectedItems,
      rowOne,
      rowTwo
    });
  }

  // put the selected items into rows for better displaying
  _getRows = selectedItems => {
    const hideDisabledLsaItems = this.props.hideDisabledLsaItems || false;
    if (!hideDisabledLsaItems) {
      return {
        rowOne: ["Health", "Alternative", "Cosmetic"],
        rowTwo: ["Personal", "FitnessAndSports", "Other"]
      };
    }

    // Get the keys where the corresponding array is non-empty
    const nonEmptyKeys = Object.entries(selectedItems).filter(([_, items]) => items.length > 0) // Filter out keys with empty arrays
    .map(([key]) => key); // Extract only the keys

    // Split the keys into two rows
    const rowOne = nonEmptyKeys.slice(0, 3); // First three keys go into rowOne
    const rowTwo = nonEmptyKeys.slice(3); // Remaining keys go into rowTwo

    return {
      rowOne,
      rowTwo
    };
  };
  _categorizeItems = async items => {
    const data = {
      Health: [],
      Alternative: [],
      Cosmetic: [],
      Personal: [],
      FitnessAndSports: [],
      Other: []
    };
    if (!items) {
      return data;
    }

    // eslint-disable-next-line array-callback-return
    const promises = items.map(item => {
      if (lsaOptions.Health.includes(item)) {
        data.Health.push(item);
      } else if (lsaOptions.Alternative.includes(item)) {
        data.Alternative.push(item);
      } else if (lsaOptions.Cosmetic.includes(item)) {
        data.Cosmetic.push(item);
      } else if (lsaOptions.Personal.includes(item)) {
        data.Personal.push(item);
      } else if (lsaOptions.FitnessAndSports.includes(item)) {
        data.FitnessAndSports.push(item);
      } else {
        data.Other.push(item);
      }
    });
    await Promise.all(promises);
    return data;
  };
  render() {
    const {
      open,
      whitelabel = {},
      hideDisabledLsaItems = false
    } = this.props;
    const {
      selectedItems,
      rowOne,
      rowTwo
    } = this.state;
    const width = rowOne?.length === 1 ? '100%' : rowOne?.length === 2 ? '50%' : '34%'; // adjust the width of the columns if the modal size is changing due to hiding certain items

    if (!this.state.selectedItems) {
      return null;
    }
    const styles = {
      lsaOptionsTitleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20,
        gap: rowOne?.length === 3 ? 0 : 20
      },
      lsaOptionRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginBottom: 20,
        gap: rowOne?.length === 3 ? 0 : 20
      },
      lsaColumnMobileTitle: {
        width: '100%',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20
      },
      lsaColumnMobile: {
        width: '100%',
        marginBottom: 20
      },
      itemBlock: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 15
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      title: i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingAccount),
      testid: "lsa-details-modal",
      open: open,
      onClose: this.props.close,
      loader: this.props.loader,
      style: rowOne?.length === 3 ? {
        width: '60%',
        maxWidth: '1300px',
        minHeight: 600
      } : {
        minHeight: 600
      },
      medium: !hideDisabledLsaItems ? false : rowOne?.length === 2
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.lsaModal.seeBelowTaxableLSACategoriesCovered)), /*#__PURE__*/React.createElement(FullScreenBlock, null, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, rowOne ? rowOne.map(row => /*#__PURE__*/React.createElement(LsaTitle, {
      title: labelsMap[row],
      hideDisabledLsaItems: hideDisabledLsaItems,
      selectedItems: selectedItems[row],
      width: width
    })) : null), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, rowOne ? rowOne.map(row => /*#__PURE__*/React.createElement(LsaColumn, {
      whitelabel: whitelabel,
      hideDisabledLsaItems: hideDisabledLsaItems,
      selectedItems: selectedItems[row],
      options: lsaOptions[row],
      width: width
    })) : null), rowTwo?.length >= 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, rowTwo ? rowTwo.map(row => /*#__PURE__*/React.createElement(LsaTitle, {
      title: labelsMap[row],
      hideDisabledLsaItems: hideDisabledLsaItems,
      selectedItems: selectedItems[row],
      width: width
    })) : null), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, rowTwo ? rowTwo.map(row => /*#__PURE__*/React.createElement(LsaColumn, {
      whitelabel: whitelabel,
      hideDisabledLsaItems: hideDisabledLsaItems,
      selectedItems: selectedItems[row],
      options: lsaOptions[row],
      width: width
    })) : null)) : null));
  }
}
export default LsaCategoriesModal;